import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, AlertCircleIcon, CheckCircleIcon, AlertTriangleIcon, HelpCircleIcon } from 'lucide-react';
import { Source } from './supplyClassesData';
interface SourceBlockProps {
  source: Source;
}
export const SourceBlock = ({
  source
}: SourceBlockProps) => {
  const [showDetails, setShowDetails] = useState(false);
  // Status icon based on status
  const StatusIcon = () => {
    switch (source.status) {
      case 'healthy':
        return <CheckCircleIcon className="text-green-500" size={18} data-id="element-67" />;
      case 'delay':
        return <AlertTriangleIcon className="text-amber-500" size={18} data-id="element-68" />;
      case 'failure':
        return <AlertCircleIcon className="text-red-500" size={18} data-id="element-69" />;
      default:
        return <HelpCircleIcon className="text-gray-400" size={18} data-id="element-70" />;
    }
  };
  // Status text based on status
  const statusText = {
    healthy: 'Healthy',
    delay: 'Delayed',
    failure: 'Failed',
    unknown: 'Unknown'
  };
  // Status color based on status
  const statusColor = {
    healthy: 'bg-green-100 text-green-800',
    delay: 'bg-amber-100 text-amber-800',
    failure: 'bg-red-100 text-red-800',
    unknown: 'bg-gray-100 text-gray-800'
  };
  return;
};